// extracted by mini-css-extract-plugin
export default {"button":"styleBtnLocation_button__V+2Ht"};